import { render, staticRenderFns } from "./SplitContent.vue?vue&type=template&id=04dd78e0"
import script from "./SplitContent.vue?vue&type=script&lang=js"
export * from "./SplitContent.vue?vue&type=script&lang=js"
import style0 from "./SplitContent.vue?vue&type=style&index=0&id=04dd78e0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports